import React from "react";
import { Link } from "react-router-dom";
import { FlaskConical } from "lucide-react";
import { useTrialAccount } from "@/hooks/useTrialAccount";

/**
 * Persistent marker shown on every authenticated page for trial accounts.
 * Renders nothing for full accounts.
 */
const TrialBanner: React.FC = () => {
  const { isTrial, recipientEmail } = useTrialAccount();
  if (!isTrial) return null;

  return (
    <div
      role="status"
      data-testid="trial-banner"
      className="sticky top-[calc(3rem+var(--env-ribbon-height))] z-10 border-b border-amber-200 bg-amber-50/95 px-4 py-2 text-xs text-amber-900 backdrop-blur-sm dark:border-amber-800 dark:bg-amber-950/80 dark:text-amber-100 sm:top-[var(--env-ribbon-height)]"
    >
      <div className="mx-auto flex w-full max-w-[1400px] flex-wrap items-center gap-x-3 gap-y-1 sm:px-2">
        <span className="inline-flex items-center gap-1.5 font-semibold uppercase tracking-wide">
          <FlaskConical className="h-3.5 w-3.5" aria-hidden />
          Trial account
        </span>
        <span className="min-w-0 flex-1">
          Inbox ingestion, team invites and account customization are turned off. Contracts, signed
          copies and Plaid links are emailed to{" "}
          <span className="font-medium">{recipientEmail || "your email"}</span> instead of the
          merchant so you can test the full flow.
        </span>
        <Link
          to="/setting"
          className="shrink-0 font-medium underline underline-offset-2 hover:text-amber-950 dark:hover:text-white"
        >
          See what's locked
        </Link>
      </div>
    </div>
  );
};

export default TrialBanner;
